import { useWalletSats } from "./useWalletSats";

export const useBitcoinBalance = () => {
  const walletSats = useWalletSats();

  return walletSats / 100_000_000;
};
